import styled from 'styled-components';

import { getPurpurBorder, getPurpurColor, getPurpurSpacing } from '@telialt/common-theme/src/purpurSelectors';

export const RoundFilledIconWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-items: center;
    line-height: 1;
    padding: ${getPurpurSpacing('150')};
    border-radius: ${getPurpurBorder('radiusFull')};
    color: ${getPurpurColor('functionalWhite')};
    background: ${getPurpurColor('brandCorePurple')};
`;
